<template>

    <multiselect :id="id"
                selectLabel=""
                selectedLabel=""
                selectGroupLabel=""
                deselectLabel=""
                deselectGroupLabel=""
                :open-direction="openDirection"
                :placeholder="placeholder"
				:tag-placeholder="tagPlaceholder"
                v-model ="selected"
                :track-by="trackBy"
                :label="label"
                :options="options" 
                :multiple="multiple"
				:taggable="taggable"
                :preselect-first="preselectFirst"
                :close-on-select="closeOnSelect"
                :clear-on-select="clearOnSelect"
				:disabled="disabled"
                
				:internal-search="internalSearch"
                @input="onSelect"
				@search-change="searchChange"
				@tag="addTag">

	</multiselect>

</template>

<script>
import '@/assets/styles/shared/vue-multiselect.min.css'

export default {
    model: {
			prop: 'value',
			event: 'select'
		},
		props: {
			id: { 
				type: String,
				default: function(){
					return 'custom-select-' + Math.round(Math.random() * 100000);
				}
			},
			value: [Object, Array], 
			placeholder: {
				type: String,
				default: ""
			},
			tagPlaceholder: {
				type: String,
				default: ""
			},
			closeOnSelect: {
				type: Boolean,
				default: true
			},
			clearOnSelect:{
				type: Boolean,
				default: true
			},
			trackBy: {
				type: String,
				default: "Id"
			},
			label: {
				type: String,
				default: "Text"
			},
			options: Array,
			multiple: {
				type: Boolean,
				default: false
			},
			taggable: {
				type: Boolean,
				default: false
			},
			preselectFirst: {
				type: Boolean,
				default: false
			},
			openDirection: {
				type: String,
				default: ""
			},
			internalSearch: {
				type: Boolean,
				default: true
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		data: function () {

			return {
				selected: this.value
			};
		},
		methods: {
			onSelect: function(value) {
				this.$emit('select', value);
			},

			searchChange: function(value) {
				this.$emit('search-change', value)
			},

			addTag: function(newTag) {
				this.$emit('tag', newTag);

			}
		},
		watch: {
			'value': function(val) {
				this.selected = val;
			}
		}
}
</script>